<script>
    import { findRelatedContent, findPagePurposeIcon } from '../../api/relatedcontent';
    import { truncText, getTopAreaHeight } from "../../utils/utils";
    import LiftUpPageBlock from './LiftUpPageBlock.vue';

    export default {
        components: {
            LiftUpPageBlock
        },
        props: {
            blockId: { type: [String, Number], default: '' },
            pageId:  { type: [String, Number], default: '' },
            page:    { type: Number, default: 0 },
            language:{ type: String, default: '' }
        },
        data: function (/* VueComponent */) {
            return {
                isLoading: false,
                moreContent: [],
                loadMore: {
                    blockId: this.blockId,
                    pageId: this.pageId,
                    page: this.page,
                    language: this.language
                },
                pagePurposeIcons: []
            };
        },
        mounted() {
        },
        methods: {
            pushDataLayerEvent(action, url, e) {
                if (e) e.preventDefault();
                if (window?.pushDataLayer) {
                    window.pushDataLayer(action, url, setTimeout(() => (window.location.href = url), 200));
                } else {
                    window.location.href = url;
                }
            },
            loadMoreContent(e) {
                this.isLoading = true;
                findRelatedContent(this.loadMore)
                    .then(response => {
                        this.moreContent.push(...response.items);
                        this.loadMore = response.loadMore;
                        response.items.forEach((item) => {
                            if (this.pagePurposeIcons.length === 0 || !this.pagePurposeIcons.find(({ name }) => name === item.liftUp.liftUpPagePurposeIcon)) {
                                if (item.liftUp.liftUpPagePurposeIcon !== null && item.liftUp.liftUpPagePurposeIcon !== '') {
                                    this.pagePurposeIcons.push({ name: item.liftUp.liftUpPagePurposeIcon });
                                }
                            }
                        });
                        if (this.pagePurposeIcons.length > 0) {
                            // Go through all found unique page-purpose icons and load those not yet loaded. Set loading to false after last icon is loaded
                            this.pagePurposeIcons.forEach((item, index) => {
                                if (!item.value) {
                                    findPagePurposeIcon({ iconId: item.name }).then(response => {
                                        item.value = response;
                                        if (index + 1 === this.pagePurposeIcons.length) {
                                            this.$nextTick(() => {
                                                this.isLoading = false;
                                            });
                                        }
                                    });
                                }
                                else if (index + 1 === this.pagePurposeIcons.length) {
                                    this.isLoading = false;
                                }
                            });
                        }
                        else {
                            this.isLoading = false;
                        }
                    })
                    .catch(() => {
                        this.isLoading = false;
                    })
            },
            renderTitle: function (rawTitle, titleLimit) {
                if (rawTitle.length > 1) {
                    return truncText(rawTitle, titleLimit);
                }
                else {
                    return rawTitle;
                }
            },
            renderIngress: function (rawIngress, ingressLimit) {
                if (rawIngress) {
                    if (rawIngress.length > 1) {
                        return truncText(rawIngress, ingressLimit);
                    }
                    else {
                        return rawIngress;
                    }
                }
                return '';
            },
            renderIcon: function (icon) {
                if (!icon) return null;
                return this.pagePurposeIcons.find(({ name }) => name === icon).value;
            }
        }
    };
</script>